import { globalModule } from "../service-provider/GlobalModule";
import { registerGlobalService } from "../service-provider/ServiceRegistry";

export interface SessionStorage {
  setStorageItem(key: string, value: string): void; //rename me setItem
  getStorageItem(key: string): string;
  clear(): void;
  removeStorageItem(key: string): void;
}

export class SessionStorageService implements SessionStorage {
  setStorageItem = (key: string, value: string) => {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  };

  getStorageItem = (key: string) => {
    const item = window.sessionStorage.getItem(key);
    return item ? JSON.parse(item) : item;
  };

  removeStorageItem = (key: string) => {
    window.sessionStorage.removeItem(key);
  };

  clear = () => {
    window.sessionStorage.clear();
  };
}

export const appSessionStorage = new SessionStorageService();
globalModule.appSessionStorage = appSessionStorage;
export default registerGlobalService(appSessionStorage as SessionStorage);
